import axios from "axios";

class DiscountsTable extends HTMLElement {
  constructor() {
    super();

    this.customerId = this.getAttribute('data-customer-id');
    this.rowTemplate = this.querySelector('#discount-row-template');
    this.tableBody = this.querySelector("tbody");

  }

  connectedCallback() {
    if (!this.customerId || !this.rowTemplate || !this.tableBody) {
      return;
    }

    this.init();
  }

  async init() {
    await this.getDiscounts();
  }

  async getDiscounts() {
    try {
      const discountCodes = await axios.get(`https://intersportapi.netlify.app/.netlify/functions/getCustomerDiscountCodes?customerId=${this.customerId}`);

      // reverse to show from newest to oldest
      for (const discountCode of discountCodes.data.reverse()) {
        if (!discountCode.used) {
          this.createRow(discountCode);
        }
      }
    } catch (err) {
      console.error("Error fetching discount codes", err);
    }
  }

  createRow(discountCode) {
    const row = this.rowTemplate.content.cloneNode(true);
    const _this = this;

    if (!row.querySelector('#code') || !row.querySelector('#amount') || !row.querySelector("#apply button")) {
      return;
    }

    row.querySelector('#code').textContent = discountCode.code;
    row.querySelector('#amount').textContent = discountCode.value;
    row.querySelector("#apply button").value = discountCode.code;
    const originalBtn = row.querySelector("#apply button").cloneNode(true);

    row.querySelector("#apply button")?.addEventListener("click", async (e) => {
      if (!e.target) {
        return;
      }

      const discountCode = e.target.value;
      const successText = e.target.querySelector("[data-success]").textContent;
      const progressHtml = e.target.querySelector('[data-progress]').innerHTML;
      e.target.innerHTML = progressHtml;

      // Disable all other buttons
      _this.tableBody.querySelectorAll("tr").forEach((otherRow) => {
        const otherRowBtn = otherRow.querySelector("#apply button");
        if (!otherRowBtn) return;
        otherRowBtn.disabled = true;
      });

      // Reset all other buttons
      _this.tableBody.querySelectorAll("tr").forEach((otherRow) => {
        const otherRowBtn = otherRow.querySelector("#apply button");
        if (!otherRowBtn) return;
        if (otherRowBtn.getAttribute('applied') == "true") {
          otherRowBtn.innerHTML = originalBtn.innerHTML;
          otherRowBtn.disabled = false;
          otherRowBtn.removeAttribute('applied');
          otherRowBtn.classList.remove('bg-grey-300');
        }
      });

      // Apply the discount code
      try {
        await Shopify.functions.applyDiscountCode(discountCode);
        e.target.disabled = true;
        e.target.classList.add("bg-grey-300");
        e.target.textContent = successText;
        e.target.setAttribute('applied', 'true');
      } catch (err) {
        console.error("Error applying discount code", err);
      }

      // Enable all other buttons
      _this.tableBody.querySelectorAll("tr").forEach((otherRow) => {
        const otherRowBtn = otherRow.querySelector("#apply button");
        if (!otherRowBtn) return;
        otherRowBtn.disabled = false;
      });
    });

    this.tableBody.appendChild(row);
  }
}

customElements.define('discounts-table', DiscountsTable);